import React from "react"
import { Button } from "../../components/Button/Button"
import { useMutation } from "react-query";
import { AuthService } from "../../services/auth.service";
import { FormikProvider, useFormik } from "formik";
import { Asserts, number, object, string } from "yup";
import { TextInput } from "../../components/FormInputs/TextInput";
import { AuthActions } from "../../zustand/auth.store";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";


export const EnterOtp = () => {
    const navigate = useNavigate()
    const validationSchema = object({
        otp: string().max(6).min(6).required().label("otp"),
    });

    const form = useFormik<Asserts<typeof validationSchema>>({
        initialValues: {
            otp: "",
        },
        validationSchema,
        onSubmit: (values) => {
           const payload = {
            "otp": values.otp,
            "phoneNumber": localStorage.getItem("resetId")
        }
              submitOtp.mutate(payload);
        },
    });

    const submitOtp = useMutation(
        async (values: {otp:string, phoneNumber: string | any }) => {
            localStorage.setItem("resetId", values.phoneNumber)
             return await AuthService.confirmOtp(values)
           },
           {
             onSuccess: (response) => {
               if (response.data.responseCode === "00") {
                 toast.success(response.data.responseMessage);
                 requestAnimationFrame(() => {
                    navigate("/reset-success");
                 });
               } else {
                 toast.error(response.data.responseMessage);
                 
               }
               
             },
             onError: (err: any) => { 
               toast.error(err.response.data.responseMessage);
               
             },
           }
    )
    return (
        <div>
            <div className="card bg-white rounded-md p-9">
                <div className="flex justify-around">
                    <img
                        src={"/images/pc-logo.svg"}
                        className=""
                        alt="Paycenter_logo"
                    />
                </div>
                <div className="mt-6">
                    <h5 className="text-center font-bold">Enter OTP</h5>
                </div>
                <div>
                    <FormikProvider value={form}>
                        <form onSubmit={form.handleSubmit}>
                            <div className="mt-4 w-80">
                                <p className="pc-text-gray text-sm">Enter the six digit otp sent to your email to verify.</p>
                            </div>
                            <div className="mt-4 w-80">
                                <TextInput
                                    type="text"
                                    label="Enter OTP"
                                    {...form.getFieldProps("otp")}
                                    placeholder="Enter OTP"
                                    context
                                />
                            </div>
                            <div className="mt-4">
                                <Button label="Confirm" className="justify-center" fullWidth disabled={false} />
                            </div>
                        </form>
                    </FormikProvider>

                </div>
            </div>

        </div>
    )
}